import {
  AUTH_SET_PASSWORD,
  FORGOT_PASSWORD_SUCCEEDED,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case AUTH_SET_PASSWORD:
      return {
        ...state,
        loading: false,
        errors: action?.error ? action?.payload?.data : null,
        status: action?.error ? 'error' : 'success',
      };
    case FORGOT_PASSWORD_SUCCEEDED:
      return {
        ...state,
        loading: false,
        errors: null,
        status: 'success',
      };
    default:
      return state;
  }
};
